import { type ComputedRef, inject, type Ref } from 'vue'
import type { CombinedError, UseQueryResponse } from '@urql/vue'
import type { InitQuery } from '@/graphql/api'
import type { Benchmark } from '@/helpers/bench.ts'

export const key = 'app.plugin.init'

export interface InitPlugin {
    error: Ref<CombinedError | undefined>
    initQueryResponse: UseQueryResponse<InitQuery>
    showRegionModal: ComputedRef<boolean>
    isInitialized: Ref<boolean>
    then: PromiseLike<void>['then']
    benchmark: Benchmark
}

export function useInit(): InitPlugin {
    return inject(key) as InitPlugin
}
